var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6344 13.3846L18.3844 24.6346C18.1498 24.8691 17.8317 25.0009 17.5 25.0009C17.1683 25.0009 16.8502 24.8691 16.6156 24.6346C16.3811 24.4 16.2493 24.0819 16.2493 23.7502C16.2493 23.4185 16.3811 23.1004 16.6156 22.8658L25.7328 13.7502H1.25C0.918479 13.7502 0.600537 13.6185 0.366117 13.3841C0.131696 13.1497 0 12.8317 0 12.5002C0 12.1687 0.131696 11.8507 0.366117 11.6163C0.600537 11.3819 0.918479 11.2502 1.25 11.2502H25.7328L16.6156 2.13458C16.3811 1.90003 16.2493 1.58191 16.2493 1.25021C16.2493 0.918502 16.3811 0.600383 16.6156 0.365832C16.8502 0.131281 17.1683 -0.000488281 17.5 -0.000488281C17.8317 -0.000488281 18.1498 0.131281 18.3844 0.365832L29.6344 11.6158C29.7506 11.7319 29.8428 11.8698 29.9057 12.0215C29.9686 12.1733 30.001 12.3359 30.001 12.5002C30.001 12.6645 29.9686 12.8271 29.9057 12.9789C29.8428 13.1306 29.7506 13.2685 29.6344 13.3846Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceRightArrow);
export default __webpack_public_path__ + "static/media/service-right-arrow.c1426ad1413ea33fbc11597adae49e4f.svg";
export { ForwardRef as ReactComponent };